import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { faBars, faInfoCircle, faXmark, faTrash } from '@fortawesome/free-solid-svg-icons';
import { CockpitChartService } from 'src/app/page/cockpit/cockpit-page/components/cockpit-chart/service/cockpit-chart.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import {
	CockpitFilter,
	CustomCockpitColumn,
	cockpitChartInterface,
	cockpitChartListInterface,
} from 'src/app/util/interfaces/cockpitRework/cockpitRework';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CockpitEditService } from './service/cockpit-edit.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-cockpit-edit',
	templateUrl: './cockpit-edit.component.html',
	styleUrls: ['./cockpit-edit.component.scss'],
})
export class CockpitEditComponent implements OnInit, AfterViewInit {
	labels: LabelsInterface = {
		lbl_edocs_carregando: 'Loading',
		lbl_geral_selecione: 'Select',
		lbl_ckp_gerenciar_ckp: 'Manage my cockpit',
		lbl_geral_voltar: 'Back',
		lbl_ckp_add_indicator: 'Add new indicator',
		lbl_ckp_indicadores_selecionados: 'Selected indicators',
		lbl_ckp_selecione_indicator_visualizar: 'Select an indicator to view it',
		lbl_geral_adicionar: 'Add',
		lbl_ckp_ordenar_indicadores: '',
		lbl_chat_analyst_configuracoes: '',
		lbl_geral_cliente_padrao: '',
		lbl_geral_usuario: '',
		lbl_geral_periodo: '',
		lbl_so_hoje: '',
		lbl_esse_mes: '',
		lbl_esse_ano: '',
		lbl_ckp_periodo_nao_aplicado_em_indicadores_concretos: '',
		lbl_adicionado_com_sucesso: '',
		lbl_ckp_indicador_indisponivel: '',
		lbl_cockpit_reload_page: '',
		lbl_geral_minuto: '',
		lbl_escalonamento_minutos: '',
		lbl_escalonamento_hora: '',
		lbl_reiniciar_cockpit: '',
		lbl_geral_reiniciar: '',
		lbl_reiniciado_com_sucesso: '',
		lbl_clique_confirmar_acao: '',
		lbl_geral_criacao_indicador_customizado: 'Custom Indicator Creation',
		lbl_kb_criar: 'Create',
		lbl_geral_criar_novo_indicador: 'Create new indicator',
		lbl_geral_salvar: 'Save',
		lbl_geral_excluir: 'Delete',
		lbl_geral_min_3_caracteres: 'Minimum 3 characters',
		lbl_removido_com_sucesso: 'Successfully removed',
		lbl_security_gerenciar: 'Manage',
		lbl_geral_adicionar_novo_indicador_personalizado: 'Add new custom indicator',
		lbl_geral_painel_gerenciamento_indicadores_customizados: 'Custom Indicators Management Panel',
		lbl_geral_nome_do_indicador: 'Indicator Name',
		lbl_geral_tipo_de_grafico: 'Chart Type',
		lbl_geral_opcoes_de_coluna: 'Column Options',
		lbl_geral_nome_de_exibicao: 'Display Name',
		lbl_geral_deletar_indicador: 'Delete Indicator',
		lbl_geral_criado_com_sucesso: 'Successfully created',
		lbl_ultimos_30_dias: 'Last 30 days',
		lbl_ultimos_3_meses: 'Last 3 months',
		lbl_ultimos_6_meses: 'Last 6 months',
		lbl_ultimos_12_meses: 'Last 12 months',
		lbl_geral_barra: 'Bar',
		lbl_circula: 'Pie',
		lbl_geral_linha: 'Line',
		lbl_geral_soma: 'Sum',
		lbl_geral_media: 'Average',
		lbl_geral_porcentagem: 'Percent',
		lbl_analista: 'Analyst',
		lbl_geral_cliente: 'Customer',
		lbl_cmdb_sla: 'SLA',
		lbl_asset_category: 'Category',
		lbl_grupo_cliente: 'Customer Group',
		lbl_formato_grafico: 'Chart Format',
		lbl_preencha_todos_asteriscos: 'Fill in at least the fields marked by *',
		lbl_filtros_disponiveis: 'Available Filters',
		lbl_geral_depto: 'Department',
		lbl_geral_indicador: 'Indicator',
		lbl_geral_site: 'Site',
		lbl_geral_localidade: 'Location',
		lbl_geral_grupo: 'Group',
		lbl_geral_competencia: 'Scope',
		lbl_salvo_com_sucesso: 'Succesful Saved',
		lbl_an_errour_occour: 'An error occurred. Please try again',
		lbl_reiniciar_filtros: 'Restart Filters',
		lbl_geral_data_inicial: 'Start Date',
		lbl_geral_data_final: 'Close Date',
		lbl_escalonamento_customizado: 'Customized',
		lbl_geral_intervalo_superior_180_dias: 'The selected range cannot exceed 180 days. Please choose a shorter period.',
		lbl_geral_data_final_menor_data_inicial: 'The end date cannot be earlier than the start date.',
		lbl_geral_avaliar: 'Evaluate',
		lbl_geral_datas_inicial_final_precisam_preenchidas: 'The start and end dates must be filled in',
	};

	icons = {
		faBars: faBars,
		faInfoCircle: faInfoCircle,
		faXmark: faXmark,
		faTrash: faTrash,
	};

	constructor(
		private CockpitEditService: CockpitEditService,
		private CockpitChartService: CockpitChartService,
		private LabelsService: LabelsService,
		private Router: Router,
		private NotificationService: NotificationService,
		public ProfileService: ProfileService,
		public PermissionService: PermissionService
	) {}

	isLoadingLabels = true;
	isLoadingAvailableCharts = true;
	isLoadingAvailableCustomCharts = true;
	isLoadingSelectedChart = false;
	isLoadingSelectedCustomChart = false;
	isExecutingAction = false;
	isResetingCockpit = false;
	isExecutingCustomAction = false;
	isResetingCustomCockpit = false;
	showCustomManage = false;
	showFilters = false;

	// Variaveis que recebem o valor selecionado
	selectedIndicatorName: string = null;
	chartType: string = null;
	chartParamValue: string = null;
	selectedColumnName: string = null;
	indicatorId: string = null;
	labelName: string = null;
	requestOption: string = null;
	confirmButtonText: any = null;
	isConfirming = false;
	interval: number = null;
	dataLoaded = false;
	buttonClicked = false;
	startDate = '';
	endDate = '';
	isOpenModalEvaluationMSP = false;

	selectedFamily: string[] = [];
	selectedDepartment: string[] = [];
	selectedScope: string[] = [];
	selectedSolutionArea: string[] = [];
	selectedSite: string[] = [];
	selectedLocation: string[] = [];
	selectedCustomer: string[] = [];

	newCustomIndicator: CustomCockpitColumn[] = [
		{
			COLUMN_NAME: '',
			type: '',
			indicatorName: '',
			label: '',
			interval: null,
			param_value: '',
		},
	];

	labelList: CustomCockpitColumn[] = [];
	listLabelsIAC: iacOptionInterface[] = [];
	clearValuesLabel = false;
	placeholderLabel = '';
	hideCustomCockpit = true;

	indicatorCustomList: CustomCockpitColumn[] = [];
	listIndicatorCustomIAC: iacOptionInterface[] = [];
	clearValuesIndicatorCustom = false;
	placeholderIndicatorCustom = '';

	requestsOptionsList: CustomCockpitColumn[] = [];
	listRequestOptionsIAC: iacOptionInterface[] = [];
	clearValuesRequestOptions = false;
	placeholderRequestOptions = '';

	readonly chartTypeList: CustomCockpitColumn[] = [
		{ chartType: 'bar' },
		// { chartType: 'line' },
		{ chartType: 'pie' },
	];

	readonly chartParamValueList: CustomCockpitColumn[] = [
		{ chartParamValue: 'sum' },
		{ chartParamValue: 'average' },
		{ chartParamValue: 'percent' },
	];

	listChartTypeIAC: iacOptionInterface[] = [];
	listChartParamValueIAC: iacOptionInterface[] = [];
	clearValuesChartType = false;
	clearValuesChartParamValue = false;
	placeholderChartType = '';

	myCockpit: cockpitChartListInterface[] = [];
	myCustomCockpit: cockpitChartListInterface[] = [];
	dragndrop = {
		initialItemIndex: 0,
		selectedItem: null,
		selectedIndex: 0,
		isSelecting: false,
		x: 0,
		y: 0,
	};

	availableCharts: cockpitChartListInterface[] = [];
	availableCustomCharts: cockpitChartListInterface[] = [];
	availableChartsIAC: iacOptionInterface[] = [];
	availableCustomChartsIAC: iacOptionInterface[] = [];

	action = '';
	actionCustom = '';
	unselectValue = false;
	unselectValueCustom = false;
	selectedChart: cockpitChartInterface[] = [];
	selectedCard: cockpitChartInterface[] = [];

	selectedCustomChart: cockpitChartInterface[] = [];
	selectedCustomCard: cockpitChartInterface[] = [];
	cockpitFilters: CockpitFilter[] = [];

	filterIndicatorFamily: genericFormInterface[] = [
		{
			name: 'hideColumns',
			label: 'lbl_geral_indicador',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];

	filterLocation: genericFormInterface[] = [
		{
			name: 'hideColumns',
			label: 'lbl_geral_localidade',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];

	filterSite: genericFormInterface[] = [
		{
			name: 'hideColumns',
			label: 'lbl_geral_site',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];

	filterSolutionArea: genericFormInterface[] = [
		{
			name: 'hideColumns',
			label: 'lbl_geral_grupo',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];

	filterScope: genericFormInterface[] = [
		{
			name: 'hideColumns',
			label: 'lbl_geral_competencia',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];

	filterDepartment: genericFormInterface[] = [
		{
			name: 'hideColumns',
			label: 'lbl_geral_depto',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];

	filterCustomer: genericFormInterface[] = [
		{
			name: 'hideColumns',
			label: 'lbl_geral_cliente',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];

	searchConfig = {
		cockpitDateRange: '0',
		cockpitReloadTime: 86_400_000,
	};

	ngOnInit(): void {
		this.setConfigDefinition();

		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;

			this.CockpitChartService.getCockpitList().subscribe((cockpitList) => {
				this.myCockpit = cockpitList;
				this.orderCockpit();
			});

			this.CockpitChartService.getCustomCockpitList('custom').subscribe((cockpitList) => {
				this.myCustomCockpit = cockpitList;
				this.orderCustomCockpit();
			});

			this.loadCharts();
		});

		this.CockpitChartService.getSelectedFilters().subscribe((filters: CockpitFilter[]) => {
			if (filters && filters.length > 0) {
				this.selectedFamily = filters[0].indicatorFamily;
				this.selectedDepartment = filters[0].department;
				this.selectedScope = filters[0].scope;
				this.selectedSolutionArea = filters[0].solutionArea;
				this.selectedSite = filters[0].site;
				this.selectedLocation = filters[0].location;
				this.selectedCustomer = filters[0].customer;
			}

			this.PermissionService.getCustomersPermissions().subscribe((permissions) => {
				for (const permission_ of permissions) {
					if (permission_.permission === 'access_request') {
						this.ProfileService.setLocalUser().subscribe((permission) => {
							if (permission.permission) {
								const items = permission.permission.split(',');
								if (items.includes('access_request')) {
									this.hideCustomCockpit = false;
								}
							}
						});
						break;
					}
				}
			});
		});

		this.getAllChartType();
		this.getAllChartParamValue();
		this.getAllRequestOptions();
		this.getAllCustomIndicator();
		this.getAllLabels();
		this.getAllFilters();
	}

	ngAfterViewInit() {
		const storedCustomDate = localStorage.getItem('customDate');

		if (storedCustomDate) {
			const storedDateObject = JSON.parse(storedCustomDate);
			this.startDate = storedDateObject.startDate;
			this.endDate = storedDateObject.endDate;
		}
	}

	getChart(id: string): void {
		if (!id) {
			this.selectedChart = [];
			this.selectedCard = [];
			this.action = '';
			return;
		}

		if (!this.validateDates()) {
			this.isLoadingSelectedChart = false;
			this.unselectValue = true;
			this.action = '';
			return;
		}

		this.isLoadingSelectedChart = true;
		this.CockpitChartService.getChartById(id).subscribe(
			(chart) => {
				this.action = 'add';
				this.selectedChart = [];
				this.selectedCard = [];

				chart.type.toLocaleLowerCase() === 'text' ? this.selectedCard.push(chart) : this.selectedChart.push(chart);
				this.isLoadingSelectedChart = false;
			},
			(error) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_ckp_indicador_indisponivel);
				this.isLoadingSelectedChart = false;
				this.unselectValue = true;
				this.action = '';
				setTimeout(() => {
					this.unselectValue = false;
				}, 1);
			}
		);
	}

	getCustomChart(id: string): void {
		if (!id) {
			this.selectedCustomChart = [];
			this.selectedCustomCard = [];
			this.actionCustom = '';
			return;
		}

		this.isLoadingSelectedCustomChart = true;
		this.CockpitChartService.getChartById(id, 'custom').subscribe(
			(chart) => {
				this.actionCustom = 'add';
				this.selectedCustomChart = [];
				this.selectedCustomCard = [];
				chart.type.toLocaleLowerCase() === 'text' ? this.selectedCustomCard.push(chart) : this.selectedCustomChart.push(chart);
				this.isLoadingSelectedCustomChart = false;
			},
			(error) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_ckp_indicador_indisponivel);
				this.isLoadingSelectedCustomChart = false;
				this.unselectValueCustom = true;
				this.actionCustom = '';
				setTimeout(() => {
					this.unselectValueCustom = false;
				}, 1);
			}
		);
	}

	addChart(): void {
		if (this.isExecutingAction || this.isResetingCockpit) return;

		this.isExecutingAction = true;
		this.CockpitChartService.addChart(this.selectedChart.length === 0 ? this.selectedCard[0].id : this.selectedChart[0].id).subscribe(
			() => {
				for (const [index, chart] of this.availableChartsIAC.entries()) {
					if (chart.value == (this.selectedChart.length === 0 ? this.selectedCard[0].id : this.selectedChart[0].id)) {
						if (this.selectedChart.length > 0 && this.selectedChart[0].type.toLocaleLowerCase() != 'text') {
							const newCockpitItem: cockpitChartListInterface = {
								id_customer: 0,
								id: this.availableCharts[index].id,
								name: this.availableCharts[index].label,
								label: this.availableCharts[index].label,
								type: '',
							};
							this.myCockpit.push(newCockpitItem);
							this.orderCockpit(this.availableCharts[index].id);
						}

						this.availableChartsIAC.splice(index, 1);
						this.availableCharts.splice(index, 1);
					}
				}

				this.unselectValue = true;
				setTimeout(() => {
					this.unselectValue = false;
				}, 1);

				this.action = '';
				this.selectedCard = [];
				this.selectedChart = [];

				this.NotificationService.setNotificationMessage(this.labels.lbl_adicionado_com_sucesso);
				this.loadCharts();
				this.isExecutingAction = false;
			}
		);
	}

	deleteChartFromList(chartId: string, index: number): void {
		if (this.isExecutingAction) return;

		this.isExecutingAction = true;

		// Guarda informações do chart antes de deletar
		const deletedChart = this.myCockpit[index];

		this.CockpitChartService.deleteChartById(chartId).subscribe(
			() => {
				// Remove da lista visual
				this.myCockpit.splice(index, 1);

				// Remove do cache ckpO
				if (localStorage.getItem('ckpO')) {
					const parseCkpO = JSON.parse(localStorage.getItem('ckpO'));
					const idIndex = parseCkpO.indexOf(chartId);
					if (idIndex > -1) {
						parseCkpO.splice(idIndex, 1);
						localStorage.setItem('ckpO', JSON.stringify(parseCkpO));
					}
				}

				// Remove do cache cockpitIndividualConfigs
				if (localStorage.getItem('cockpitIndividualConfigs')) {
					try {
						const configs = JSON.parse(localStorage.getItem('cockpitIndividualConfigs'));
						if (configs[chartId]) {
							delete configs[chartId];
							localStorage.setItem('cockpitIndividualConfigs', JSON.stringify(configs));
						}
					} catch (error) {
						console.error('Erro ao remover do cockpitIndividualConfigs:', error);
					}
				}

				// Adiciona de volta para a lista de disponíveis
				this.availableCharts.push(deletedChart);
				this.availableCharts.sort((a, b) => {
					const la = this.labels[a.label] || a.name;
					const lb = this.labels[b.label] || b.name;
					return la > lb ? 1 : la < lb ? -1 : 0;
				});

				// Atualiza o autocomplete
				this.availableChartsIAC = [];
				for (const item of this.availableCharts) {
					const newIacOption: iacOptionInterface = {
						name: this.labels[item.label] || item.name,
						value: item.id,
					};
					this.availableChartsIAC.push(newIacOption);
				}

				this.NotificationService.setNotificationMessage(this.labels.lbl_removido_com_sucesso);
				this.isExecutingAction = false;
			},
			(error) => {
				console.error('Erro ao deletar chart:', error);
				this.NotificationService.setNotificationMessage(this.labels.lbl_an_errour_occour);
				this.isExecutingAction = false;
			}
		);
	}

	deleteCustomChartFromList(chartId: string, index: number): void {
		if (this.isExecutingCustomAction) return;

		this.isExecutingCustomAction = true;

		// Guarda informações do chart antes de deletar
		const deletedChart = this.myCustomCockpit[index];

		this.CockpitChartService.deleteChartById(chartId, 'custom').subscribe(
			() => {
				// Remove da lista visual
				this.myCustomCockpit.splice(index, 1);

				// Remove do cache ckpC
				if (localStorage.getItem('ckpC')) {
					const parseCkpC = JSON.parse(localStorage.getItem('ckpC'));
					const idIndex = parseCkpC.indexOf(chartId);
					if (idIndex > -1) {
						parseCkpC.splice(idIndex, 1);
						localStorage.setItem('ckpC', JSON.stringify(parseCkpC));
					}
				}

				// Remove do cache cockpitIndividualConfigs
				if (localStorage.getItem('cockpitIndividualConfigs')) {
					try {
						const configs = JSON.parse(localStorage.getItem('cockpitIndividualConfigs'));
						if (configs[chartId]) {
							delete configs[chartId];
							localStorage.setItem('cockpitIndividualConfigs', JSON.stringify(configs));
						}
					} catch (error) {
						console.error('Erro ao remover do cockpitIndividualConfigs:', error);
					}
				}

				// Adiciona de volta para a lista de disponíveis
				this.availableCustomCharts.push(deletedChart);
				this.availableCustomCharts.sort((a, b) => {
					const la = this.labels[a.label] || a.name;
					const lb = this.labels[b.label] || b.name;
					return la > lb ? 1 : la < lb ? -1 : 0;
				});

				// Atualiza o autocomplete
				this.availableCustomChartsIAC = [];
				for (const item of this.availableCustomCharts) {
					const newIacOption: iacOptionInterface = {
						name: this.labels[item.label] || item.name,
						value: item.id,
					};
					this.availableCustomChartsIAC.push(newIacOption);
				}

				this.NotificationService.setNotificationMessage(this.labels.lbl_removido_com_sucesso);
				this.isExecutingCustomAction = false;
			},
			(error) => {
				console.error('Erro ao deletar custom chart:', error);
				this.NotificationService.setNotificationMessage(this.labels.lbl_an_errour_occour);
				this.isExecutingCustomAction = false;
			}
		);
	}

	addCustomChart(): void {
		if (this.isExecutingCustomAction || this.isResetingCustomCockpit) return;

		this.isExecutingCustomAction = true;
		this.CockpitChartService.addChart(
			this.selectedCustomChart.length === 0 ? this.selectedCustomCard[0].id : this.selectedCustomChart[0].id,
			'custom'
		).subscribe(() => {
			for (const [index, chart] of this.availableCustomChartsIAC.entries()) {
				if (
					chart.value === (this.selectedCustomChart.length === 0 ? this.selectedCustomCard[0].id : this.selectedCustomChart[0].id)
				) {
					if (this.selectedCustomChart.length > 0 && this.selectedCustomChart[0].type.toLocaleLowerCase() != 'text') {
						const newCockpitItem: cockpitChartListInterface = {
							id_customer: 0,
							id: this.availableCustomCharts[index].id,
							name: this.availableCustomCharts[index].label,
							label: this.availableCustomCharts[index].label,
							type: '',
						};
						this.myCustomCockpit.push(newCockpitItem);
						this.orderCustomCockpit(this.availableCustomCharts[index].id);
					}

					this.availableCustomChartsIAC.splice(index, 1);
					this.availableCustomCharts.splice(index, 1);
				}
			}

			this.unselectValueCustom = true;
			setTimeout(() => {
				this.unselectValueCustom = false;
			}, 1);

			this.actionCustom = '';
			this.selectedCustomCard = [];
			this.selectedCustomChart = [];

			this.NotificationService.setNotificationMessage(this.labels.lbl_adicionado_com_sucesso);
			this.loadCharts();
			this.isExecutingCustomAction = false;
		});
	}

	holdCockpitItem(item: cockpitChartListInterface, index: number): void {
		this.dragndrop.isSelecting = true;
		this.dragndrop.initialItemIndex = index;
		this.dragndrop.selectedItem = item;
	}

	reorderCockpit(): void {
		const temporary = this.myCockpit[this.dragndrop.initialItemIndex];
		this.myCockpit.splice(this.dragndrop.initialItemIndex, 1);
		this.myCockpit.splice(this.dragndrop.selectedIndex, 0, temporary);
		this.dragndrop.isSelecting = false;
		this.dragndrop.selectedItem = null;

		const cockpitOrder = [];
		for (const item of this.myCockpit) {
			cockpitOrder.push(item.id);
		}

		localStorage.setItem('ckpO', JSON.stringify(cockpitOrder));
	}

	reorderCustomCockpit(): void {
		const temporaryCustom = this.myCustomCockpit[this.dragndrop.initialItemIndex];
		this.myCustomCockpit.splice(this.dragndrop.initialItemIndex, 1);
		this.myCustomCockpit.splice(this.dragndrop.selectedIndex, 0, temporaryCustom);
		this.dragndrop.isSelecting = false;
		this.dragndrop.selectedItem = null;

		const cockpitCustomOrder = [];
		for (const item of this.myCustomCockpit) {
			cockpitCustomOrder.push(item.id);
		}

		localStorage.setItem('ckpC', JSON.stringify(cockpitCustomOrder));
	}

	moveSelectedItem(index: number): void {
		this.dragndrop.selectedIndex = index;
	}

	moveGhost(event: MouseEvent): void {
		this.dragndrop.x = event.clientX + 1;
		this.dragndrop.y = event.clientY + 1;
	}

	orderCockpit(newId?: string): void {
		if (localStorage.getItem('ckpO')) {
			const newOrderCockpitCharts = [];
			const parseCkpO = JSON.parse(localStorage.getItem('ckpO'));
			if (newId) {
				parseCkpO.push(newId);
				localStorage.setItem('ckpO', JSON.stringify(parseCkpO));
			}
			for (const [index, cockpitItemId] of parseCkpO.entries()) {
				for (const item of this.myCockpit) {
					if (item.id === cockpitItemId) {
						newOrderCockpitCharts.splice(index, 0, item);
					}
				}
			}
			this.myCockpit = newOrderCockpitCharts;
		} else {
			const cockpitOrder = [];
			for (const item of this.myCockpit) {
				cockpitOrder.push(item.id);
			}

			localStorage.setItem('ckpO', JSON.stringify(cockpitOrder));
		}
	}

	orderCustomCockpit(newId?: string): void {
		if (localStorage.getItem('ckpC')) {
			const newOrderCustomCockpitCharts = [];
			const parseCkpO = JSON.parse(localStorage.getItem('ckpC'));
			if (newId) {
				parseCkpO.push(newId);
				localStorage.setItem('ckpC', JSON.stringify(parseCkpO));
			}
			for (const [index, cockpitItemId] of parseCkpO.entries()) {
				for (const item of this.myCustomCockpit) {
					if (item.id === cockpitItemId) {
						newOrderCustomCockpitCharts.splice(index, 0, item);
					}
				}
			}
			this.myCustomCockpit = newOrderCustomCockpitCharts;
		} else {
			const cockpitCustomOrder = [];
			for (const item of this.myCustomCockpit) {
				cockpitCustomOrder.push(item.id);
			}

			localStorage.setItem('ckpC', JSON.stringify(cockpitCustomOrder));
		}
	}

	setSearchBase(level: string): void {
		localStorage.setItem('ckpL', level);
		this.searchConfig.cockpitDateRange = level;

		// Atualiza o period_type no cockpitFilters
		const cachedFilters = localStorage.getItem('cockpitFilters');
		if (cachedFilters) {
			try {
				const filters = JSON.parse(cachedFilters);

				// Mapeia o level para period_type
				let periodType = 'today';
				switch (level) {
					case '0': {
						periodType = 'today';
						break;
					}
					case '1': {
						periodType = 'month';
						break;
					}
					case '2': {
						periodType = 'week';
						break;
					}
					case '3': {
						periodType = 'custom';
						break;
					}
				}

				filters.period_type = periodType;

				// Limpa as datas se não for custom
				if (level !== '3') {
					filters.startDate = '';
					filters.endDate = '';
				}

				localStorage.setItem('cockpitFilters', JSON.stringify(filters));
			} catch (error) {
				console.error('Erro ao atualizar cockpitFilters:', error);
			}
		}

		if (level !== '3') {
			localStorage.removeItem('customDate');
		}
	}

	setCustomDate(): void {
		if (localStorage.getItem('ckpL') === '3') {
			const regexData = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
			const customDate = { startDate: this.startDate, endDate: this.endDate };

			if (
				!regexData.test(this.startDate) ||
				!regexData.test(this.endDate) ||
				Number.parseInt(this.startDate).toString().length < 4 ||
				Number.parseInt(this.endDate).toString().length < 4
			)
				return;

			const startDateObject = new Date(customDate.startDate);
			const endDateObject = new Date(customDate.endDate);

			if (endDateObject < startDateObject) {
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_data_final_menor_data_inicial);
				this.endDate = '';
				return;
			}

			const timeDiff = endDateObject.getTime() - startDateObject.getTime();
			const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

			if (diffDays > 180) {
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_intervalo_superior_180_dias);
				this.endDate = '';
				return;
			}

			localStorage.setItem('customDate', JSON.stringify(customDate));

			// Atualiza startDate e endDate no cockpitFilters
			const cachedFilters = localStorage.getItem('cockpitFilters');
			if (cachedFilters) {
				try {
					const filters = JSON.parse(cachedFilters);
					filters.startDate = this.startDate;
					filters.endDate = this.endDate;
					filters.period_type = 'custom';
					localStorage.setItem('cockpitFilters', JSON.stringify(filters));
				} catch (error) {
					console.error('Erro ao atualizar cockpitFilters:', error);
				}
			}
		}
	}

	setConfigDefinition(): void {
		// if( localStorage.getItem('ckpL') && ['0','1', '2', '3'].includes(localStorage.getItem('ckpL')) ) {
		//   this.searchConfig.cockpitDateRange = localStorage.getItem('ckpL');
		// } else {
		//   localStorage.setItem('ckpL', '0');
		// }

		if (isNaN(Number.parseInt(localStorage.getItem('cockpitReloadTime')))) {
			localStorage.setItem('cockpitReloadTime', '300000');
		} else {
			this.searchConfig.cockpitReloadTime = Number.parseInt(localStorage.getItem('cockpitReloadTime'));
		}
	}

	setReloadTimer(selectedMS: number): void {
		this.searchConfig.cockpitReloadTime = selectedMS;
		localStorage.setItem('cockpitReloadTime', selectedMS.toString());
	}

	redirectTo(to: string): void {
		this.Router.navigate([to]);
	}

	loadCharts(): void {
		this.isLoadingLabels = true;
		this.isLoadingAvailableCharts = true;
		this.isLoadingAvailableCustomCharts = true;
		this.availableChartsIAC = [];
		this.availableCustomChartsIAC = [];
		this.CockpitChartService.getAvailableCharts().subscribe((chartList) => {
			this.availableCharts = chartList;

			this.availableCharts.sort((a, b) => {
				const la = this.labels[a.label];
				const lb = this.labels[b.label];
				return la > lb ? 1 : la < lb ? -1 : 0;
			});

			for (const item of this.availableCharts) {
				const newIacOption: iacOptionInterface = {
					name: this.labels[item.label],
					value: item.id,
				};
				this.availableChartsIAC.push(newIacOption);
			}

			this.isLoadingAvailableCharts = false;
			this.isLoadingLabels = false;
		});

		this.CockpitChartService.getAvailableCustomCharts().subscribe((chartList) => {
			this.availableCustomCharts = chartList;

			this.availableCustomCharts.sort((a, b) => {
				const la = this.labels[a.label];
				const lb = this.labels[b.label];
				return la > lb ? 1 : la < lb ? -1 : 0;
			});

			for (const item of this.availableCustomCharts) {
				const newIacOption: iacOptionInterface = {
					name: this.labels[item.label],
					value: item.id,
				};
				this.availableCustomChartsIAC.push(newIacOption);
			}

			this.isLoadingAvailableCustomCharts = false;
			this.isLoadingLabels = false;
		});
	}

	restartCockpit(): void {
		this.isResetingCockpit = true;
		this.isResetingCustomCockpit = true;
		this.CockpitEditService.restartCockpit().subscribe(
			(res) => {
				localStorage.removeItem('ckpO');
				localStorage.removeItem('ckpC');
				localStorage.setItem('ckpO', '[]');
				localStorage.setItem('ckpC', '[]');
				this.myCockpit = [];
				this.myCustomCockpit = [];
				this.NotificationService.setNotificationMessage(this.labels.lbl_reiniciado_com_sucesso);
				this.isResetingCockpit = false;
				this.isResetingCustomCockpit = false;
				this.loadCharts();
			},
			(res) => {
				this.isResetingCockpit = false;
				this.isResetingCustomCockpit = false;
			}
		);
	}

	confirmButton(elementReference: HTMLElement): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}

	postCustomIndicator(): void {
		this.newCustomIndicator = [
			{
				COLUMN_NAME: this.requestOption,
				type: this.chartType,
				indicatorName: this.selectedIndicatorName,
				label: this.labelName,
				interval: this.interval,
				param_value: this.chartParamValue,
			},
		];

		for (const field in this.newCustomIndicator[0]) {
			if (!this.newCustomIndicator[0][field] || this.newCustomIndicator[0][field] === '') {
				this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			} else {
				this.CockpitChartService.postCustomIndicator(this.newCustomIndicator)
					.subscribe(() => {
						this.loadCharts();
						this.getAllCustomIndicator();
						this.showCustomManage = false;
						this.resetFormFields();
					})
					.add(() => {
						this.resetFormFields();
						this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
					});
			}
			break;
		}
	}

	resetFormFields(): void {
		this.labelName = '';
		this.selectedIndicatorName = '';
		this.chartType = '';
		this.requestOption = '';
		this.interval = null;
		this.chartParamValue = '';
		this.newCustomIndicator = [
			{
				COLUMN_NAME: '',
				type: '',
				indicatorName: '',
				label: '',
				interval: null,
				param_value: '',
			},
		];
	}

	getAllChartType(): void {
		this.listChartTypeIAC = [];
		for (const item of this.chartTypeList) {
			const newIacOptionChart: iacOptionInterface = {
				name: item.chartType,
				value: item.chartType,
			};

			switch (newIacOptionChart.name) {
				case 'bar': {
					newIacOptionChart.name = this.labels.lbl_geral_barra;
					break;
				}
				case 'pie': {
					newIacOptionChart.name = this.labels.lbl_circula;
					break;
				}
				case 'line': {
					newIacOptionChart.name = this.labels.lbl_geral_linha;
					break;
				}
				default: {
					newIacOptionChart.name;
					break;
				}
			}

			this.listChartTypeIAC.push(newIacOptionChart);
		}
	}

	getAllChartParamValue(): void {
		this.listChartParamValueIAC = [];
		for (const item of this.chartParamValueList) {
			const newIacOptionChart: iacOptionInterface = {
				name: item.chartParamValue,
				value: item.chartParamValue,
			};

			switch (newIacOptionChart.name) {
				case 'sum': {
					newIacOptionChart.name = this.labels.lbl_geral_soma;
					break;
				}
				case 'average': {
					newIacOptionChart.name = this.labels.lbl_geral_media;
					break;
				}
				case 'percent': {
					newIacOptionChart.name = this.labels.lbl_geral_porcentagem;
					break;
				}
				default: {
					newIacOptionChart.name;
					break;
				}
			}

			this.listChartParamValueIAC.push(newIacOptionChart);
		}
	}

	getAllRequestOptions(): void {
		this.CockpitChartService.getCustomFilter().subscribe((requestOption) => {
			this.listRequestOptionsIAC = [];
			this.requestsOptionsList = [];
			this.requestsOptionsList = requestOption;
			for (const item of this.requestsOptionsList) {
				const newIacOptionRequests: iacOptionInterface = {
					name: item.COLUMN_NAME,
					value: item.COLUMN_NAME,
				};

				switch (newIacOptionRequests.name) {
					case 'customer': {
						newIacOptionRequests.name = this.labels.lbl_geral_cliente;
						break;
					}
					case 'sla': {
						newIacOptionRequests.name = this.labels.lbl_cmdb_sla;
						break;
					}
					case 'enduser': {
						newIacOptionRequests.name = this.labels.lbl_geral_usuario;
						break;
					}
					case 'customer_group': {
						newIacOptionRequests.name = this.labels.lbl_grupo_cliente;
						break;
					}
					case 'category': {
						newIacOptionRequests.name = this.labels.lbl_asset_category;
						break;
					}
					case 'analyst': {
						newIacOptionRequests.name = this.labels.lbl_analista;
						break;
					}
					default: {
						newIacOptionRequests.name;
						break;
					}
				}

				this.listRequestOptionsIAC.push(newIacOptionRequests);
			}
		});
	}

	getAllLabels(): void {
		this.CockpitChartService.getLabels().subscribe((labels) => {
			this.listLabelsIAC = [];
			this.labelList = [];
			this.labelList = labels;
			for (const item of this.labelList) {
				const newIacOptionLabels: iacOptionInterface = {
					name: item.label,
					value: item.label,
				};
				this.listLabelsIAC.push(newIacOptionLabels);
			}
		});
	}

	getAllCustomIndicator(): void {
		this.CockpitChartService.getAllCustomIndicator().subscribe((indicator) => {
			this.listIndicatorCustomIAC = [];
			this.indicatorCustomList = [];
			this.indicatorCustomList = indicator;
			for (const item of this.indicatorCustomList) {
				const newIacOptionIndicator: iacOptionInterface = {
					name: item.indicatorName,
					value: item.idIndicator,
					commonGroup: item.type,
				};
				this.listIndicatorCustomIAC.push(newIacOptionIndicator);
			}
		});
	}

	getChartType(chartType: string): void {
		this.chartType = chartType;
	}

	getChartParamValue(chartParameterValue: string): void {
		this.chartParamValue = chartParameterValue;
	}

	getRequestOption(requestOption: string): void {
		this.requestOption = requestOption;
	}

	getIdIndicator(idIndicator: string): void {
		this.indicatorId = idIndicator;
	}

	getLabelName(LabelName: string): void {
		this.labelName = LabelName;
	}

	handleDeleteClick(): void {
		if (this.isConfirming) {
			this.deleteCustomIndicator();
		} else {
			this.isConfirming = true;
			this.confirmButtonText = this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
			setTimeout(() => {
				this.isConfirming = false;
			}, 5000);
		}
	}

	deleteCustomIndicator(): void {
		if (this.indicatorId !== '') {
			this.CockpitChartService.deleteCustomIndicator(this.indicatorId).subscribe((res) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_removido_com_sucesso);
				this.loadCharts();
				this.getAllCustomIndicator();
				this.showCustomManage = false;
			});
		}
	}

	changeInterval(value: number): void {
		this.interval = value;
	}

	getAllFilters(): void {
		this.CockpitChartService.getFilter().subscribe((filters) => {
			this.cockpitFilters = filters;
			this.filterIndicatorFamily[0].items = this.cockpitFilters[0].indicatorFamily;
			this.filterDepartment[0].items = this.cockpitFilters[0].department;
			this.filterScope[0].items = this.cockpitFilters[0].scope;
			this.filterSolutionArea[0].items = this.cockpitFilters[0].solutionArea;
			this.filterSite[0].items = this.cockpitFilters[0].site;
			this.filterLocation[0].items = this.cockpitFilters[0].location;
			this.filterCustomer[0].items = this.cockpitFilters[0].customer;
			this.generateConfigurationForm();
			this.dataLoaded = true;
		});
	}

	generateConfigurationForm(): void {
		let arrayIndicatorFamily = [];
		let arrayDepartment = [];
		let arrayScope = [];
		let arraySolutionArea = [];
		let arraySite = [];
		let arrayLocation = [];
		let arrayCustomer = [];

		arrayIndicatorFamily = this.filterIndicatorFamily[0].items;
		arrayDepartment = this.filterDepartment[0].items;
		arrayScope = this.filterScope[0].items;
		arraySolutionArea = this.filterSolutionArea[0].items;
		arraySite = this.filterSite[0].items;
		arrayLocation = this.filterLocation[0].items;
		arrayCustomer = this.filterCustomer[0].items;

		this.filterIndicatorFamily[0].items = [];
		this.filterDepartment[0].items = [];
		this.filterScope[0].items = [];
		this.filterSolutionArea[0].items = [];
		this.filterSite[0].items = [];
		this.filterLocation[0].items = [];
		this.filterCustomer[0].items = [];

		this.filterIndicatorFamily[0].rawValues = [];
		this.filterDepartment[0].rawValues = [];
		this.filterScope[0].rawValues = [];
		this.filterSolutionArea[0].rawValues = [];
		this.filterSite[0].rawValues = [];
		this.filterLocation[0].rawValues = [];
		this.filterCustomer[0].rawValues = [];

		for (const availableItems of arrayIndicatorFamily) {
			const newItem: genericFormInterface['items'][number] = {
				name: availableItems.name,
				label: availableItems.name,
				value: availableItems.name,
				values: [availableItems.name],
			};

			this.filterIndicatorFamily[0].items.push(newItem);

			if (this.selectedFamily) {
				for (const item of this.selectedFamily) {
					if (item === availableItems.name) {
						this.filterIndicatorFamily[0].values.push(newItem);
						this.filterIndicatorFamily[0].rawValues.push(newItem.name);
					}
				}
			}
		}

		for (const availableItems of arrayDepartment) {
			const newItem: genericFormInterface['items'][number] = {
				name: availableItems.name,
				label: availableItems.name,
				value: availableItems.name,
				values: [availableItems.name],
			};
			if (this.selectedDepartment) {
				for (const item of this.selectedDepartment) {
					if (item === availableItems.name) {
						this.filterDepartment[0].values.push(newItem);
						this.filterDepartment[0].rawValues.push(newItem.name);
					}
				}
			}

			this.filterDepartment[0].items.push(newItem);
		}

		for (const availableItems of arrayScope) {
			const newItem: genericFormInterface['items'][number] = {
				name: availableItems.name,
				label: availableItems.name,
				value: availableItems.name,
				values: [availableItems.name],
			};

			this.filterScope[0].items.push(newItem);

			if (this.selectedScope) {
				for (const item of this.selectedScope) {
					if (item === availableItems.name) {
						this.filterScope[0].values.push(newItem);
						this.filterScope[0].rawValues.push(newItem.name);
					}
				}
			}
		}

		for (const availableItems of arraySolutionArea) {
			const newItem: genericFormInterface['items'][number] = {
				name: availableItems.name,
				label: availableItems.name,
				value: availableItems.name,
				values: [availableItems.name],
			};

			this.filterSolutionArea[0].items.push(newItem);

			if (this.selectedSolutionArea) {
				for (const item of this.selectedSolutionArea) {
					if (item === availableItems.name) {
						this.filterSolutionArea[0].values.push(newItem);
						this.filterSolutionArea[0].rawValues.push(newItem.name);
					}
				}
			}
		}

		for (const availableItems of arraySite) {
			const newItem: genericFormInterface['items'][number] = {
				name: availableItems.name,
				label: availableItems.name,
				value: availableItems.name,
				values: [availableItems.name],
			};

			this.filterSite[0].items.push(newItem);

			if (this.selectedSite) {
				for (const item of this.selectedSite) {
					if (item === availableItems.name) {
						this.filterSite[0].values.push(newItem);
						this.filterSite[0].rawValues.push(newItem.name);
					}
				}
			}
		}

		for (const availableItems of arrayLocation) {
			const newItem: genericFormInterface['items'][number] = {
				name: availableItems.name,
				label: availableItems.name,
				value: availableItems.id,
				values: [availableItems.name],
			};

			this.filterLocation[0].items.push(newItem);

			if (this.selectedLocation) {
				for (const item of this.selectedLocation) {
					if (item === availableItems.name) {
						this.filterLocation[0].values.push(newItem);
						this.filterLocation[0].rawValues.push(newItem.name);
					}
				}
			}
		}

		for (const availableItems of arrayCustomer) {
			const newItem: genericFormInterface['items'][number] = {
				name: availableItems.name,
				label: availableItems.name,
				value: availableItems.id,
				values: [availableItems.name],
			};

			this.filterCustomer[0].items.push(newItem);

			if (this.selectedCustomer) {
				for (const item of this.selectedCustomer) {
					if (item === availableItems.name) {
						this.filterCustomer[0].values.push(newItem);
						this.filterCustomer[0].rawValues.push(newItem.name);
					}
				}
			}
		}
	}

	saveFilter(): void {
		const filterItems = {
			selectedLocation: this.filterLocation[0].rawValues,
			selectedSite: this.filterSite[0].rawValues,
			selectedSolutionArea: this.filterSolutionArea[0].rawValues,
			selectedFamily: this.filterIndicatorFamily[0].rawValues,
			selectedDepartment: this.filterDepartment[0].rawValues,
			selectedScope: this.filterScope[0].rawValues,
			selectedCustomer: this.filterCustomer[0].rawValues,
		};

		try {
			this.CockpitChartService.postFilter(JSON.stringify(filterItems)).subscribe(() => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
			});
		} catch {
			this.NotificationService.setNotificationMessage(this.labels.lbl_an_errour_occour);
		}
	}

	deleteFilter(): void {
		this.CockpitChartService.deleteFilters().subscribe(() => {
			this.NotificationService.setNotificationMessage(this.labels.lbl_reiniciado_com_sucesso);
			this.filterIndicatorFamily[0].values = [];
			this.filterIndicatorFamily[0].rawValues = [];
			this.filterDepartment[0].values = [];
			this.filterDepartment[0].rawValues = [];
			this.filterScope[0].values = [];
			this.filterScope[0].rawValues = [];
			this.filterSolutionArea[0].values = [];
			this.filterSolutionArea[0].rawValues = [];
			this.filterLocation[0].values = [];
			this.filterLocation[0].rawValues = [];
			this.filterSite[0].values = [];
			this.filterSite[0].rawValues = [];
			this.filterCustomer[0].values = [];
			this.filterCustomer[0].rawValues = [];

			this.loadCharts();
		});
	}

	// Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal
	modalClose(event: Event, ignorePropagation: boolean): void {
		if (event.target === document.querySelector('#modalClose')) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
		if (ignorePropagation) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
	}

	openModalEvaluationMSP() {
		this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
	}
	// Final Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal

	validateDates(): boolean {
		if (localStorage.getItem('ckpL') === '3' && (!this.startDate || !this.endDate)) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_datas_inicial_final_precisam_preenchidas);
			return false;
		}
		return true;
	}

	onBackClick(): void {
		if (!this.validateDates()) {
			return;
		}

		this.Router.navigate(['/cockpit']);
	}
}
